// Primary Care Provider status (Malaffi patient-level ROL). Options come from the nb_pcp_status lookup
// (api/lookup/pcp-statuses) as {id, name, code}; PCP_NA means the doctor is not the PCP.

export const PCP_STOPPED_CODE = "PCP_Stopped";

// Exact speciality names; "Sports and Family Medicine Specialist" must not match.
const PCP_SPECIALITIES = ["Family Medicine Specialist", "Family Medicine Consultant"];

export const isPcpSpeciality = (specialityName) => PCP_SPECIALITIES.includes(specialityName);

export const isPcpStopped = (pcpStatus) => pcpStatus?.code === PCP_STOPPED_CODE;

export const pcpStatusLabel = (pcpStatus) => pcpStatus ? `${pcpStatus.code} - ${pcpStatus.name}` : null;
